import {
  CloseOutline24Icon,
  StarsOutline24Icon,
} from "@vygruppen/spor-icon-react";
import { TrainResumedElement } from "features/Header/TrainResumed/TrainResumedElement";
import { TrainResumed } from "features/Header/TrainResumed/useTrainResumed";
import { trainIdKey } from "features/VehicleSidebar/AffectedTrains/utils/utils";
import { SegmentedPanel } from "shared/components/SegmentedPanel";
import {
  Box,
  ColorMode,
  Flex,
  IconButton,
  Separator,
  Text,
  useColorMode,
} from "shared/components/Spor";
import { ObtrusiveScrollCss } from "shared/components/transitions/scroll";
import styled from "styled-components";

const AlertsContainer = styled.div<{ $colorMode: ColorMode }>`
  display: flex;
  width: 430px;
  min-height: 5rem;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colorBackgroundMain};
  border: 1px solid ${({ theme }) => theme.colorOutlineMain};
  border-radius: 12px;
  box-sizing: border-box;
  z-index: 1;
  box-shadow: ${({ theme }) => theme.boxShadow};
`;

const TrainResumedContainer = styled.div`
  ${ObtrusiveScrollCss};
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  gap: 6px;
  max-height: 55vh;
  padding: 12px;
`;

export const AlertsModal = ({
  trainsResumed,
  setTrainsResumed,
  setShowModal,
}: {
  trainsResumed: TrainResumed[];
  setTrainsResumed: (value: TrainResumed[]) => void;
  setShowModal: (value: boolean) => void;
}) => {
  const { colorMode } = useColorMode();

  return (
    <div
      style={{
        marginTop: "48px",
        marginLeft: "66px",
        position: "absolute",
        transform: "translateX(-100%)",
      }}
    >
      <AlertsContainer $colorMode={colorMode}>
        <Flex
          alignItems="center"
          justifyContent="space-between"
          px="12px"
          pt="9px"
          pb="6px"
        >
          <Text fontWeight="bold">Oppdaterte hendelser</Text>
          <IconButton
            variant="ghost"
            size="sm"
            aria-label="close"
            icon={<CloseOutline24Icon />}
            onClick={() => {
              setShowModal(false);
            }}
          />
        </Flex>
        <Separator />
        <Box>
          {trainsResumed.length === 0 && (
            <Flex alignItems="center" gap="6px" p="12px">
              <StarsOutline24Icon />
              <Text>Her var det ryddig og fint!</Text>
            </Flex>
          )}
          <TrainResumedContainer>
            <SegmentedPanel panelStyle={[]} dashedLineVariant="secondary">
              {trainsResumed.map((trainResumed) => (
                <TrainResumedElement
                  key={`${trainResumed.trainInformationUuid}-${trainIdKey(trainResumed.trainIdentifier)}`}
                  trainResumed={trainResumed}
                  trainResumedIsFinished={() =>
                    setTrainsResumed(
                      trainsResumed.filter((it) => trainResumed !== it),
                    )
                  }
                />
              ))}
            </SegmentedPanel>
          </TrainResumedContainer>
        </Box>
      </AlertsContainer>
    </div>
  );
};
